import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import {
  convertPriceUnit,
  convertQuantityUnit,
  formatWonToEokMan,
  fromM2,
  toM2,
} from "../function";
import * as s from "../InputPage.styles";
import { AnalysisForm, AreaUnit, areaUnitList } from "../machine";
import { useFormattedNumberField } from "./useFormattedNumberField";

interface Props {
  formData: AnalysisForm;
  setFormData: Dispatch<SetStateAction<AnalysisForm>>;
  agentRevenueRef: React.RefObject<HTMLDivElement>;
}
function FarmingAgentSection({
  formData,
  setFormData,
  agentRevenueRef,
}: Props) {
  const [openUnitChange, setOpenUnitChange] = useState(false);
  // 단위 교환 버튼
  const areaUnitRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      // 열려있는 드롭다운에 따라 참조할 ref 선택
      const currentRef = areaUnitRef.current;

      if (currentRef && !currentRef.contains(target)) {
        setOpenUnitChange(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changeAgentUnit = (unit: AreaUnit) => {
    setFormData((prev) => {
      const baseQuantity = convertQuantityUnit(prev.quantity, prev.unit, unit);
      const baseUnitPrice = convertPriceUnit(
        prev.farmAgentUnitPrice,
        prev.unit,
        unit
      );
      return {
        ...prev,
        quantity: baseQuantity,
        farmAgentUnitPrice: baseUnitPrice,
        unit: unit,
      };
    });
    setOpenUnitChange(false);
  };

  // 영농대행 단가
  // const [agentPriceInputMode, setAgentPriceInputMode] = useState<
  //   "revenue" | "unitPrice"
  // >("revenue");
  // const toggleAgentPriceInputMode = () => {
  //   setAgentPriceInputMode((prev) =>
  //     prev === "revenue" ? "unitPrice" : "revenue"
  //   );
  // };

  // 경작기간 매출
  // const {
  //   display: agentRevenueDisplay,
  //   setDisplay: setAgentRevenueDisplay,
  //   handleChange: handleAgentRevenueChange,
  //   handleBlur: rawAgentRevenueBlur,
  // } = useFormattedNumberField({
  //   baseValue: formData.farmAgentRevenue,
  //   onChangeBaseValue: (value) => {
  //     setFormData((prev) => {
  //       const farmAgentAreaM2 = toM2(prev.farmAgentArea, "평");
  //       const farmAgentAreaInUnit = fromM2(farmAgentAreaM2, formData.unit);
  //       console.log(farmAgentAreaInUnit);
  //       const unitPrice = Math.max(
  //         Math.round((value * 10000) / Number(farmAgentAreaInUnit.toFixed(2))),
  //         0
  //       );

  //       return {
  //         ...prev,
  //         farmAgentRevenue: value || 0,
  //         farmAgentUnitPrice: unitPrice || 0,
  //       };
  //     });
  //   },
  // });

  // const handleAgentRevenueBlur = () => {
  //   if (!agentRevenueDisplay) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       farmAgentRevenue: 0,
  //       farmAgentUnitPrice: 0,
  //       farmAgentRate: 0,
  //     }));
  //   }
  //   rawAgentRevenueBlur();
  // };

  // 단가
  const {
    display: agentUnitPriceDisplay,
    handleChange: handleAgentUnitPriceChange,
    handleBlur: rawAgentUnitPriceBlur,
  } = useFormattedNumberField({
    baseValue: formData.farmAgentUnitPrice,
    onChangeBaseValue: (unitPrice) => {
      setFormData((prev) => {
        return {
          ...prev,
          farmAgentUnitPrice: unitPrice || 0,
          // farmAgentRevenue: revenueWon || 0,
        };
      });
    },
  });

  const handleAgentUnitPriceBlur = () => {
    if (!agentUnitPriceDisplay) {
      setFormData((prev) => ({
        ...prev,
        farmAgentUnitPrice: 0,
      }));
    }
    rawAgentUnitPriceBlur();
  };

  // 영농대행 비율
  // const [agentPercentInputMode, setAgentPercentInputMode] = useState<
  //   "price" | "percent"
  // >("price");
  // const toggleAgentPercentInputMode = () => {
  //   setAgentPercentInputMode((prev) =>
  //     prev === "price" ? "percent" : "price"
  //   );
  // };

  // 연 비용
  // const {
  //   display: agentCostDisplay,
  //   handleChange: handleAgentCostChange,
  //   handleBlur: handleAgentCostBlur,
  // } = useFormattedNumberField({
  //   baseValue: formData.farmAgentCost,
  //   onChangeBaseValue: (value) => {
  //     setFormData((prev) => {
  //       const sales = prev.farmAgentRevenue;
  //       const rate = Math.max(Math.round((value / sales) * 100), 0);

  //       return {
  //         ...prev,
  //         farmAgentCost: value || 0,
  //         farmAgentRate: rate || 0,
  //       };
  //     });
  //   },
  // });

  // 비용 비율
  const {
    display: agentRateDisplay,
    handleChange: handleAgentRateChange,
    handleBlur: handleAgentRateBlur,
  } = useFormattedNumberField({
    baseValue: formData.farmAgentRate,
    isPrice: false,
    onChangeBaseValue: (value) => {
      setFormData((prev) => {
        return {
          ...prev,
          farmAgentRate: value || 0,
        };
      });
    },
  });

  return (
    <s.Section>
      <s.SectionTitleContainer>
        <s.SectionTitle>1-1. 영농대행 (공동영농)</s.SectionTitle>
        <s.UnitWrapper ref={areaUnitRef}>
          <s.UnitChangeButton onClick={() => setOpenUnitChange(true)}>
            <span>단위</span>
            {formData.unit}
          </s.UnitChangeButton>
          {openUnitChange && (
            <s.UnitChangeDropdown>
              {areaUnitList.map((i) => (
                <s.UnitChangeDropdownItem
                  key={i}
                  onClick={() => changeAgentUnit(i)}
                  $active={formData.unit === i}
                >
                  {i}
                  {formData.unit === i && (
                    <img src="/asset/images/check/Check24Green2.svg" alt="" />
                  )}
                </s.UnitChangeDropdownItem>
              ))}
            </s.UnitChangeDropdown>
          )}
        </s.UnitWrapper>
      </s.SectionTitleContainer>

      <s.SectionInner $top={8}>
        <s.Label>
          <s.LabelTitle>영농대행 평균 단가</s.LabelTitle>
          영농대행의 면적당 용역 비용
        </s.Label>
        <s.InputMessageContainer>
          <s.InputWrapper>
            <s.Input
              placeholder="영농대행의 면적당 단가를 입력해주세요"
              value={agentUnitPriceDisplay}
              onChange={(e) => handleAgentUnitPriceChange(e.target.value)}
              onBlur={handleAgentUnitPriceBlur}
            />
            <span>원/{formData.unit}</span>
          </s.InputWrapper>
          <s.InputMessage>
            {formatWonToEokMan(formData.farmAgentUnitPrice)}
          </s.InputMessage>
        </s.InputMessageContainer>
      </s.SectionInner>

      <s.SectionInner $top={8}>
        <s.Label>
          <s.LabelTitle>영농대행 평균 비용</s.LabelTitle>
          영농대행의 매출 대비 비용 비율
        </s.Label>
        <s.InputWrapper>
          <s.Input
            placeholder="영농대행의 비용 비율을 입력해주세요"
            value={agentRateDisplay}
            onChange={(e) => handleAgentRateChange(e.target.value)}
            onBlur={handleAgentRateBlur}
          />
          <span>%</span>
        </s.InputWrapper>
      </s.SectionInner>

      {/* {agentPriceInputMode === "revenue" ? (
        <s.SectionInner $top={8} ref={agentRevenueRef}>
          <s.Label>
            <s.LabelTitle>
              경작기간 매출
              <s.ChangeInputUnit onClick={toggleAgentPriceInputMode}>
                <img src="/asset/images/change/refresh-black.svg" alt="" />
                단가 입력
              </s.ChangeInputUnit>
            </s.LabelTitle>
          </s.Label>
          <s.InputMessageContainer>
            <s.InputWrapper $error={!formData.farmAgentRevenue}>
              <s.Input
                placeholder="영농대행의 경작기간 매출을 입력해주세요"
                value={agentRevenueDisplay}
                onChange={(e) => handleAgentRevenueChange(e.target.value)}
                onBlur={handleAgentRevenueBlur}
              />
              <span>만원</span>
            </s.InputWrapper>
            {agentRevenueDisplay && (
              <s.InputMessage>
                {formatManToEokMan(Number(agentRevenueDisplay))}
              </s.InputMessage>
            )}
            {!formData.farmAgentRevenue && (
              <s.InputErrorMessage>
                영농대행의 매출은 필수로 입력해야 합니다.
              </s.InputErrorMessage>
            )}
          </s.InputMessageContainer>
        </s.SectionInner>
      ) : (
        <s.SectionInner $top={8} ref={agentRevenueRef}>
          <s.Label>
            <s.LabelTitle>
              단가
              <s.ChangeInputUnit onClick={toggleAgentPriceInputMode}>
                <img src="/asset/images/change/refresh-black.svg" alt="" />
                매출 입력
              </s.ChangeInputUnit>
            </s.LabelTitle>
          </s.Label>
          <s.InputMessageContainer>
            <s.InputWrapper $error={!formData.farmAgentRevenue}>
              <s.Input
                placeholder="면적당 경작기간 판매 단가를 입력해주세요"
                value={agentUnitPriceDisplay}
                onChange={(e) => handleAgentUnitPriceChange(e.target.value)}
                onBlur={handleAgentUnitPriceBlur}
              />
              <span>원 / {formData.unit}</span>
            </s.InputWrapper>
            {!formData.farmAgentRevenue && (
              <s.InputErrorMessage>
                영농대행의 단가는 필수로 입력해야 합니다.
              </s.InputErrorMessage>
            )}
          </s.InputMessageContainer>
        </s.SectionInner>
      )} */}

      {/* {agentPriceInputMode === "revenue" ? (
        <s.SectionInner>
          <s.Label>
            <s.LabelTitle>단가</s.LabelTitle>
            영농대행의 면적당 생산 단가
          </s.Label>
          <s.FixedValue>
            {agentUnitPriceDisplay || 0}원 / {formData.unit}
          </s.FixedValue>
        </s.SectionInner>
      ) : (
        <s.SectionInner>
          <s.Label>
            <s.LabelTitle>매출</s.LabelTitle>
            영농대행의 경작기간 매출
          </s.Label>
          <s.FixedValue>{agentRevenueDisplay || 0}만원</s.FixedValue>
        </s.SectionInner>
      )} */}

      {/* {agentPercentInputMode === "price" ? (
        <s.SectionInner $top={8}>
          <s.Label>
            <s.LabelTitle>
              경작기간 비용
              <s.ChangeInputUnit onClick={toggleAgentPercentInputMode}>
                <img src="/asset/images/change/refresh-black.svg" alt="" />
                비용 비율 입력
              </s.ChangeInputUnit>
            </s.LabelTitle>
          </s.Label>
          <s.InputMessageContainer>
            <s.InputWrapper>
              <s.Input
                placeholder="영농대행의 경작기간 비용을 입력해주세요"
                value={agentCostDisplay}
                onChange={(e) => handleAgentCostChange(e.target.value)}
                onBlur={handleAgentCostBlur}
              />
              <span>만원</span>
            </s.InputWrapper>
            <s.InputMessage>
              {formatManToEokMan(formData.farmAgentCost)}
            </s.InputMessage>
          </s.InputMessageContainer>
        </s.SectionInner>
      ) : (
        <s.SectionInner $top={8}>
          <s.Label>
            <s.LabelTitle>
              비용 비율
              <s.ChangeInputUnit onClick={toggleAgentPercentInputMode}>
                <img src="/asset/images/change/refresh-black.svg" alt="" />
                비용 입력
              </s.ChangeInputUnit>
            </s.LabelTitle>
          </s.Label>
          <s.InputWrapper>
            <s.Input
              placeholder="매출 대비 비용 비율을 입력해주세요"
              value={agentRateDisplay}
              onChange={(e) => handleAgentRateChange(e.target.value)}
              onBlur={handleAgentRateBlur}
            />
            <span>%</span>
          </s.InputWrapper>
        </s.SectionInner>
      )}

      {agentPercentInputMode === "price" ? (
        <s.SectionInner>
          <s.Label>
            <s.LabelTitle>비용 비율</s.LabelTitle>
            영농대행의 매출 대비 비용 비율
          </s.Label>
          <s.InputMessageContainer>
            <s.FixedValue>{formData.farmAgentRate}%</s.FixedValue>
            {formData.farmAgentCost > formData.farmAgentRevenue && (
              <s.InputWarningMessage style={{ padding: 0 }}>
                비용이 매출보다 높습니다.
              </s.InputWarningMessage>
            )}
          </s.InputMessageContainer>
        </s.SectionInner>
      ) : (
        <s.SectionInner>
          <s.Label>
            <s.LabelTitle>비용</s.LabelTitle>
            영농대행의 경작기간 비용
          </s.Label>
          <s.InputMessageContainer>
            <s.FixedValue>
              {formData.farmAgentCost.toLocaleString()}만원
            </s.FixedValue>
            {formData.farmAgentCost > formData.farmAgentRevenue && (
              <s.InputWarningMessage style={{ padding: 0 }}>
                비용이 매출보다 높습니다.
              </s.InputWarningMessage>
            )}
          </s.InputMessageContainer>
        </s.SectionInner>
      )} */}
    </s.Section>
  );
}

export default FarmingAgentSection;
